module.exports = __webpack_public_path__ + "img/gu.33dfed53.png";